var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconFilter = function SvgIconFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 1.75c.568 0 1.03.461 1.03 1.03 0 2.145-.88 4.197-2.424 5.676l-.214.198-3.415 3.035a2.523 2.523 0 0 0-.84 1.692l-.008.196v4.537c0 .3-.131.584-.356.779l-.102.077-4.6 3.067a1.03 1.03 0 0 1-1.595-.742l-.006-.115v-7.603c0-.656-.256-1.284-.707-1.753l-.141-.135-3.415-3.035A7.866 7.866 0 0 1 1.77 2.78c0-.531.402-.968.918-1.024L2.8 1.75h18.4zm-1.122 2.059H3.92l.055.265a5.81 5.81 0 0 0 1.596 2.85l.204.19L9.19 10.15a4.591 4.591 0 0 1 1.533 3.182l.006.245v5.679l2.54-1.693v-3.986c0-1.227.494-2.402 1.361-3.26l.179-.167 3.415-3.036a5.808 5.808 0 0 0 1.8-3.04l.054-.265z",
    fill: "none",
    fillRule: "evenodd"
  })));
};

export default SvgIconFilter;